// extracted by mini-css-extract-plugin
module.exports = {"container":"waitTime_container__3M7Es","content":"waitTime_content__2LAO8","bold":"waitTime_bold__3qINL","button":"waitTime_button__1Ai9M button_button__2n_ir"};